import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardText, Col, Row, Table } from 'reactstrap';
import { colorArr,sortByOptionsForSearchTracker, performanceBySKUtype } from '../helper';
import { setCurrencyFormat } from '../../../utils/helpers';


const PerformanceBySKUTable = ({ data, customClass }) => {
   
  const [rowData, setData] = useState([]);
  // const [headerData, setHeaderData] = useState([]);
  const [isSortable, setIsSortable] = useState(false);
  const [isResizable, setIsResizable] = useState(true);
  const [withPagination, setWithPaginationTable] = useState(true);
  const [withSearchEngine, setWithSearchEngine] = useState(true);
  const [sortBySelected, setSortBySelected] = useState(sortByOptionsForSearchTracker[0])

  useEffect(() => {
    setData(data || []);
}, [data]);

  const currentDataBySKU = {};
  const allDataData = {};
  const dataToPlot = [];

  rowData.forEach((item) => {
    if (item && currentDataBySKU[item?.sku]) {
        currentDataBySKU[item?.sku]?.push(item)
    } else if (item) {
        if (!item?.sku || item?.sku === 'null') {
            currentDataBySKU?.['N/A']?.push(item)
        } else {
            currentDataBySKU[item?.sku] = [item]
        }
    }

    if (item && allDataData[item?.day]) {
        allDataData[item?.day]?.push(item)
    } else if (item) {
        if (!item?.day || item?.day === 'null') {
            allDataData?.['N/A']?.push(item)
        } else {
            allDataData[item?.day] = [item]
        }
    }
  })

  const currentSKU = Object.keys(currentDataBySKU);
  const dates = Object.keys(allDataData);
  
  const headerData = [];

  for (let index = 0; index < dates.length; index += 1) {
    const date = dates[index];
    headerData.push({
        Header: date.toString(),
        accessor: date.toString(),
        disableGlobalFilter: false,
        // rightAlign: true,
        width: 100, 
        // sortType       
    })
    // console.log(element)
  }
 
  const reduceCallback = (acc, currentRow) => {   
    if (acc[currentRow.day]) {
      acc?.[currentRow.day]?.push(currentRow)
    } else {
      acc[currentRow.day] = [currentRow]
    }    
    return acc
  }

  for (let index = 0; index < currentSKU.length; index += 1) {
    const sku = currentSKU[index];
    const currentSKUData = currentDataBySKU?.[sku] ?? [];       

    const dateWiseData = currentSKUData?.reduce(reduceCallback, {})
    const dateWiseFinalData = Object.keys(dateWiseData).reduce((acc, currentDate) => {
            const salesAmountSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.salesAmount === '-' ? 0  : Number(item.salesAmount)))), 0) ?? 0;
            const profitSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.profit === '-' ? 0  : Number(item.profit)))), 0) ?? 0;
            const ordersCountSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ordersCount === '-' ? 0  : Number(item.ordersCount)))), 0) ?? 0;
            const unitsSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.quantity === '-' ? 0  : Number(item.quantity)))), 0) ?? 0;
            const organicOrdersSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.organicOrders === '-' ? 0  : Number(item.organicOrders)))), 0) ?? 0;
            const organicUnitsSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.organicUnits === '-' ? 0  : Number(item.organicUnits)))), 0) ?? 0;
            const promotionsSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.promotions === '-' ? 0  : Number(item.promotions)))), 0) ?? 0;
            const refundsSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.refunds === '-' ? 0  : Number(item.refunds)))), 0) ?? 0;
            const sessionsSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.sessions === '-' ? 0  : Number(item.sessions)))), 0) ?? 0;
            const conversionsSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.conversions === '-' ? 0  : Number(item.conversions)))), 0) ?? 0;
            const unitSessionPercentageSum = dateWiseData[currentDate].
            reduce((accum, item) => Number(Number(Number(accum) +
            (item.unitSessionPercentage === '-' ? 0  : Number(item.unitSessionPercentage)))), 0) ?? 0;
            const ppcSalesPercentageSum = dateWiseData[currentDate].
            reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcSalesPercentage === '-' ? 0  : Number(item.ppcSalesPercentage)))), 0) ?? 0;
            const ppcOrdersSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcOrders === '-' ? 0  : Number(item.ppcOrders)))), 0) ?? 0;
            const ppcUnitsSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcUnits === '-' ? 0  : Number(item.ppcUnits)))), 0) ?? 0;
            const ppcSalesSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcSales === '-' ? 0  : Number(item.ppcSales)))), 0) ?? 0;
            const ppcCostSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcCost === '-' ? 0  : Number(item.ppcCost)))), 0) ?? 0;
            const ppcImpressionsSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcImpressions === '-' ? 0  : Number(item.ppcImpressions)))), 0) ?? 0;
            const ppcClicksSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcClicks === '-' ? 0  : Number(item.ppcClicks)))), 0) ?? 0;
            const ppcCostPerClickSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcCostPerClick === '-' ? 0  : Number(item.ppcCostPerClick)))), 0) ?? 0;
            const ppcConversionSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcConversion === '-' ? 0  : Number(item.ppcConversion)))), 0) ?? 0;
            const ppcCostPerOrderSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.ppcCostPerOrder === '-' ? 0  : Number(item.ppcCostPerOrder)))), 0) ?? 0;
            const acosSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.acos === '-' ? 0  : Number(item.acos)))), 0) ?? 0;
            const tacosPercentageSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.tacosPercentage === '-' ? 0  : Number(item.tacosPercentage)))), 0) ?? 0;
            const marginPercentageSum = dateWiseData[currentDate].reduce((accum, item) => Number(Number(Number(accum) +
            (item.marginPercentage === '-' ? 0  : Number(item.marginPercentage)))), 0) ?? 0;
        acc[currentDate] = {
            // currentData: dateWiseData[currentDate]
            salesAmount: salesAmountSum.toFixed(2).toString(),
            profit: profitSum.toFixed(2).toString(),
            ordersCount: ordersCountSum.toString(),
            units: unitsSum.toString(),
            organicOrders: organicOrdersSum.toString(),
            organicUnits: organicUnitsSum.toString(),
            promotions: promotionsSum.toString(),
            refunds: refundsSum.toString(),
            sessions: sessionsSum.toString(),
            conversions: sessionsSum === 0 ? 0 : ((ordersCountSum / sessionsSum)*100).toFixed(2).toString(),
            unitSessionPercentage: sessionsSum === 0 ? 0 : ((unitsSum / sessionsSum)*100).toFixed(2).toString(),
            ppcSalesPercentage: salesAmountSum === 0 ? 0 : ((ppcSalesSum / salesAmountSum)*100).toFixed(2).toString(),
            ppcOrders: ppcOrdersSum.toString(),
            ppcUnits: ppcUnitsSum.toString(),
            ppcSales: ppcSalesSum.toFixed(2).toString(),
            ppcCost: ppcCostSum.toFixed(2).toString(),
            ppcImpressions: ppcImpressionsSum.toString(),
            ppcClicks: ppcClicksSum.toString(),
            ppcCostPerClick: ppcCostPerClickSum.toFixed(2).toString(),
            ppcConversion: ppcClicksSum === 0 ? 0 : ((ppcOrdersSum / ppcClicksSum)*100).toFixed(2).toString(),
            ppcCostPerOrder: ppcOrdersSum === 0 ? 0 : (ppcCostSum / ppcOrdersSum).toFixed(2).toString(),
            acos: ppcSalesSum === 0 ? 0 : ((ppcCostSum / ppcSalesSum)*100).toFixed(2).toString(),
            tacosPercentage: salesAmountSum === 0 ? 0 : ((ppcCostSum / salesAmountSum)*100).toFixed(2).toString(),
            marginPercentage: salesAmountSum === 0 ? 0 : ((profitSum / salesAmountSum)*100).toFixed(2).toString()
        }
        return acc
    }, {})
    
    dataToPlot.push({
        keyword: sku,
        // searchVolume: salesAmountSum.toString(),
        // keywordSales: salesAmountSum.toString(),
        // type: {
        //     organicType: 'organic',
        //     sponsoredPosition: 'Sponsored'
        // },
        dateWiseFinalData
    })
  } 

  // const sortBy = sortBySelected?.value;
  // if (sortBy === 'searchVolume') {    
  //   dataToPlot = dataToPlot?.sort((a, b) =>
  //   parseInt(b?.[sortBy], 10) - parseInt(a?.[sortBy], 10))
  // } else if (sortBy === 'keywordSales') {
  //   dataToPlot = dataToPlot?.sort((a, b) =>
  //   parseInt(b?.[sortBy], 10) - parseInt(a?.[sortBy], 10))
  // }
  // else if (sortBy === 'keyword') {
  //   dataToPlot = dataToPlot?.sort((a, b) =>
  //     a?.[sortBy]?.toLowerCase().localeCompare(b?.[sortBy]?.toLowerCase()))
  // }

  const handleColumnType = (value, column) => {
    let columnValue = '';
    if (column === 'conversions' || column === 'unitSessionPercentage' 
    || column === 'ppcSalesPercentage' || column === 'ppcConversion' || 
    column === 'acos' || column === 'tacosPercentage' || column === 'marginPercentage') {
      columnValue = `${setCurrencyFormat(value, false)}%`
    }
    else if (column === 'salesAmount' || column === 'profit' ||
    column === 'ppcSales' || column === 'ppcCost' || column === 'ppcCostPerClick'
    || column === 'ppcCostPerOrder') {
      columnValue = `${setCurrencyFormat(value, true)}`
    }
    else {
      columnValue = `${setCurrencyFormat(value, false)}`
    }
    // console.log(columnValue)
    return columnValue;
  }  

  return (
    // <Col md={12} lg={12}>
      <Card>
        <CardBody className={`${customClass} pl-0 pr-0`}>
          <div>
          {/* <div className="form__form-group mb-3 col-md-12" id='dvTable'> */}
            {/* <Row>
            <Col md="11" className='pr-0'>
            <div className="form__form-group mb-0">
              <span className="form__form-group-label">Filter</span>
              <div className="form__form-group-field">
                    <Select
                      value={sortBySelected}
                      options={sortByOptionsForSearchTracker}
                      clearable={false}
                      placeholder='Select one'
                      className="sku-select_filter-250"
                      onChange={event => setSortBySelected(event)}
                      classNamePrefix="react-select"                      
                    />
                  </div>
            </div>
          </Col>
            </Row> */}
              {/* <div 
                className="row justify-content-center align-items-center mb-3"
                id="dvFilter"
                 >
               <div className="col-12" >
                  <span className="form__form-group-label font-weight-bold">
                    Sort By</span>
                  <div className="form__form-group-field">
                    <Select
                      value={sortBySelected}
                      options={sortByOptionsForSearchTracker}
                      clearable={false}
                      placeholder='Select one'
                      className="search-select_filter-200"
                      onChange={event => setSortBySelected(event)}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
              </div> */}
            {/* </div> */}
            <div>
              <Table responsive striped hover className="dashboard__table-orders" 
                width="100%" >
                  <thead>
                    <tr>
                      <th style={{ position: 'sticky', left: 0, background: 'white', zIndex: 1,
                       textAlign: 'left', minWidth: '150px'  }}>Type</th>
                      {dates.map((item, index) => (
                        <th style={{ textAlign: 'center', }}>{item}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {performanceBySKUtype?.length ? performanceBySKUtype?.map(dataValue => (
                      <tr>
                        <td style={{ position: 'sticky', left: 0, background: 'white', zIndex: 1,
                        paddingTop: '2px', paddingBottom: '2px', }}>{dataValue?.title}
                        </td>
                        {dates.map((item, index) => (
                          <td style={{
                            paddingTop: '2px', paddingBottom: '2px', paddingLeft: '3px',
                            paddingRight: '3px', marginLeft: '0px', marginRight: '0px',
                          }}>
                            <Card body style={{
                              // background: dataValue?.categoryWiseAmountTotal?.[item]?.RepurchaseRate > 0
                              //   ? dataValue?.categoryWiseAmountTotal?.[item]?.ColorCode : colorArr[20],
                              
                              marginBottom: '0px',
                              marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
                              paddingRight: '6px'
                            }}>
                              <CardText style={{
                                color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                                paddingTop: '0px', marginBottom: '0px'
                              }}>
                                {handleColumnType(dataToPlot[0]?.dateWiseFinalData?.
                                  [item]?.[dataValue?.value],dataValue?.value)}
                                {/* {setCurrencyFormat(dataToPlot[0]?.dateWiseFinalData?.
                                  [item]?.[dataValue], false)} % */}
                              </CardText>                          
                            </Card>

                          </td>
                        ))}
                      </tr>
                )) : 'No data to display'}
                  </tbody>
              </Table>
            </div>
          </div>         
        </CardBody>
      </Card>
    // </Col>
  );
};

PerformanceBySKUTable.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  customClass: PropTypes.string,
};

PerformanceBySKUTable.defaultProps = {
  customClass: ''
}

export default PerformanceBySKUTable;
